export { kybValidators } from './kybValidators';
export { merchantValidators } from './merchantValidators';

export const isValidEmail = (email?: string) =>
  /(.+)@(.+)\.(.+)$/.test(email ?? '');
